import { render, staticRenderFns } from "./FormTask.vue?vue&type=template&id=2a7aa453"
import script from "./FormTask.vue?vue&type=script&lang=js"
export * from "./FormTask.vue?vue&type=script&lang=js"
import style0 from "./FormTask.vue?vue&type=style&index=0&id=2a7aa453&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports